/**
 * Investor-facing 2% success fee (Settings, pricing cards, express signup,
 * follow popup, investor profile). Set true to show it again. The UI and
 * `paysFee` fields stay in the codebase.
 */
export const SUCCESS_FEE_LIVE = false;
